import {Injectable} from '@angular/core';
import {DisputeStatusFilter, OperationTypeOrNone} from '@npck/coid-frontend-api';
import {SessionStorageService} from 'ngx-webstorage';
import {DISPUTE_FILTER} from './browser-storage.keys';

const DATE_FIELDS = ['createdFrom', 'createdTo', 'updatedFrom', 'updatedTo'] as const;

@Injectable({
    providedIn: 'root',
})
export class DisputeFilterStateService {

    constructor(private sessionStorage: SessionStorageService) {
    }

    get(): DisputeFilter | undefined {
        const stored = this.sessionStorage.retrieve(DISPUTE_FILTER) as DisputeFilter & {range?: unknown};
        if (!stored || 'range' in stored) {
            this.clear();
            return undefined;
        }
        return reviveDates(stored);
    }

    set(filter: DisputeFilter): void {
        if (isEmptyDisputeFilter(filter)) {
            this.clear();
            return;
        }
        this.sessionStorage.store(DISPUTE_FILTER, filter);
    }

    clear(): void {
        this.sessionStorage.clear(DISPUTE_FILTER);
    }
}

export interface DisputeFilter {
    query?: string;
    onlyWithNewEvents?: boolean;
    disputeStatuses?: DisputeStatusFilter[];
    createdFrom?: Date;
    createdTo?: Date;
    createdFromTime?: string;
    createdToTime?: string;
    updatedFrom?: Date;
    updatedTo?: Date;
    updatedFromTime?: string;
    updatedToTime?: string;
    operationTypesOrNone?: OperationTypeOrNone[];
    minAmount?: number;
    maxAmount?: number;
    senderProviderIds?: string[];
    receiverProviderIds?: string[];
    invertedFields?: string[];
}

function reviveDates(filter: DisputeFilter): DisputeFilter {
    const revived = {...filter};
    DATE_FIELDS.forEach(field => revived[field] = filter[field] && new Date(filter[field]));
    return revived;
}

function isEmptyDisputeFilter(filter: DisputeFilter): boolean {
    return !filter.query?.trim()
        && Object.entries(filter)
            .filter(([key]) => key !== 'query')
            .every(([, value]) => Array.isArray(value) ? !value.length : value == null || value === '' || value === false);
}
